import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';

const CallbackPage = () => {
    const navigate = useNavigate();
    const { login, isAuthenticated, isLoading, user } = useKindeAuth();
    const [hasAttemptedCallback, setHasAttemptedCallback] = useState(false);

    useEffect(() => {
        const handleCallback = async () => {
            if (hasAttemptedCallback) {
                return;
            }
            setHasAttemptedCallback(true);

            try {
                if (user) {
                    navigate('/welcome');
                } else {
                    console.log('User object is null or undefined after authentication');
                    navigate('/welcome');
                }
            } catch (error) {
                console.error('Error handling callback:', error);
                console.log('Error details:', JSON.stringify(error, null, 2));
                navigate('/welcome');
            }
        };

        const attemptLogin = async () => {
            try {
                await login();
            } catch (error) {
                console.error('Error during login:', error);
                navigate('/welcome');
            }
        };

        if (isLoading) {
        } else if (isAuthenticated && !hasAttemptedCallback) {
            handleCallback();
        } else if (!isAuthenticated && !isLoading) {
            attemptLogin();
        }
    }, [login, navigate, isAuthenticated, isLoading, user, hasAttemptedCallback]);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return null;
};

export default CallbackPage;
